<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: p_fy
 * @LastEditTime: 2019-07-18 20:51:34
 * @Description: 罐区供给详情信息页面。
 -->
<!--  详情显示页面  -->
<template>
  <div class="supply-item-details">
    <div class="base-info">
      <div>基本信息</div>
      <ul>
        <li :title="supply.storageLocationLabel">
          <span>库房位置</span> {{ supply.storageLocationLabel }}
        </li>
        <li :title="supply.leaseTermLabel">
          <span>起租年限</span> {{ supply.leaseTermLabel }}
        </li>
        <li :title="supply.storageTankShapeLabel">
          <span>储罐形状</span> {{ supply.storageTankShapeLabel }}
        </li>
        <li :title="supply.cargoName">
          <span>货物名称</span> {{ supply.cargoName }}
        </li>
        <li :title="supply.tankTypeLabel">
          <span>货物类型</span> {{ supply.tankTypeLabel }}
        </li>
        <li :title="supply.detailedLocation">
          <span>详细地址</span> {{ supply.detailedLocation }}
        </li>
        <li :title="supply.leaseTime">
          <span>起租日期</span> {{ supply.leaseTime }}
        </li>
        <li :title="`${supply.storageTankStandard}m³`">
          <span>储罐规格</span> {{ supply.storageTankStandard }}m³
        </li>
        <li :title="`${supply.storageTankHeight}米`">
          <span>储罐高度</span> {{ supply.storageTankHeight }}米
        </li>
        <li :title="supply.fireInformation">
          <span>消防信息</span> {{ supply.fireInformation }}
        </li>
        <li :title="supply.storageTankTypeLabel">
          <span>储罐型号</span> {{ supply.storageTankTypeLabel }}
        </li>
        <li :title="`${supply.leasePotCount}个`">
          <span>起租罐数</span> {{ supply.leasePotCount }}个
        </li>
        <li :title="`${supply.tenantablePotCount}个`">
          <span>可租罐数</span> {{ supply.tenantablePotCount }}个
        </li>
        <li :title="`${supply.storageTankDiameter}米`">
          <span>储罐直径</span> {{ supply.storageTankDiameter }}米
        </li>
        <li />
        <li :title="`${supply.potArea}m³`">
          <span>罐区容积</span> {{ supply.potArea }}m³
        </li>
        <li :title="supply.fireResistanceRatingLabel">
          <span>罐区耐火等级</span> {{ supply.fireResistanceRatingLabel }}
        </li>
        <li :title="supply.fireQualificationLabel">
          <span>消防资质</span> {{ supply.fireQualificationLabel }}
        </li>
        <li :title="`${supply.expectPrice}元/罐/天`">
          <span>租金</span> {{ supply.expectPrice }}元/罐/天
        </li>
        <li :title="supply.appointmentDate">
          <span>预约时间</span> {{ supply.appointmentTime }}
        </li>
      </ul>
    </div>
    <div class="contact-info">
      <div>联系人</div>
      <ul>
        <li>
          <span>联系人</span> {{ supply.linkMan }}
        </li>
        <li>
          <span>联系电话</span> {{ supply.telephone }}
        </li>
      </ul>
    </div>
    <div class="imgs-info">
      <div>图片</div>
      <ul v-if="storageUrl(supply)" v-viewer>
        <li v-for="(item , index) in storageUrl(supply)" :key="index">
          <img :src="item | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
        </li>
      </ul>
      <div>备注</div>
      <span>{{ supply.remarks }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TankSupplyInfo',
  props: {
    supply: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    storageUrl(supply) { // 图片回调
      return (supply) => {
        if (supply.storageUrl == null || supply.storageUrl == '') {
          return false
        }
        return supply.storageUrl.split(',').filter(n => n) // 数组去空
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$perfix: "supply-item";
$main-color: rgb(190, 35, 22);
@keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    position: relative;
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        ul {
          columns: 3;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      &.contact-info {
        ul {
          width: 50%;
          columns: 2;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      &.imgs-info {
        // word-wrap: break-word;
        word-break: break-all;
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            img {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
</style>
